import loadable from '@loadable/component';

export const OrgDashboardEditJobPageLoadable = loadable(
  () => import('./OrgDashboardEditJobPage'),
  { resolveComponent: (module) => module.OrgDashboardEditJobPage },
);
